import { BusinessCaseSelect } from "../../details/components/BusinessCaseSelect";
import { UPDATE_SIMULATION_BUSINESS_CASE } from "../../queries";
import { SimulatorUserRole } from "apps/platform-client/client/src/models/generated/graphql";
import { useSetRecoilState } from "recoil";
import { snackbarUpdateStatus } from "../../../../store/simulator";
import { useModelsMutation } from "apps/platform-client/client/src/hooks/useModelsModule";

interface IBusinessCaseInputProps {
	simulationId: string;
	value: string | null;
	userRole: SimulatorUserRole;
}

export const BusinessCaseInput = (props: IBusinessCaseInputProps) => {
	const { value, userRole, simulationId } = props;

	const [mutateSimulation] = useModelsMutation(UPDATE_SIMULATION_BUSINESS_CASE);
	const disabled = ![SimulatorUserRole.Editor, SimulatorUserRole.Owner].includes(userRole);
	const setBusinessCaseSnackbarUpdateStatus = useSetRecoilState(snackbarUpdateStatus);

	const handleOnChange = (newValue: string | null) => {
		mutateSimulation({
			variables: { request: { id: simulationId, businessCase: newValue ?? "" } },
			onError: (error) => {
				setBusinessCaseSnackbarUpdateStatus((prevState) => ({
					...prevState,
					hasError: true,
					simulationId: [...prevState.simulationId, simulationId],
				}));
				console.error("Error updating Business case tag:", error);
			},
		});
	};

	return <BusinessCaseSelect disabled={disabled} value={value} onChange={handleOnChange} />;
};
